export default "__VITE_ASSET__b62c0d6c__"